// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpLy41sBqwAVj7C29joP{align-items:center;gap:9px;width:100%;margin-top:-3px;display:flex}.FuSD4VbkFIE3NARHatlX{flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"firstStepActions": `SpLy41sBqwAVj7C29joP`,
	"registrationRequired": `FuSD4VbkFIE3NARHatlX`
};
export default ___CSS_LOADER_EXPORT___;
